<div class="vc-page">
  <div class="vc-panel">
    <div class="vc-header">
      <div class="vc-header-avatar">💬</div>
      <div class="vc-header-text">
        <strong>Messages</strong>
        <span>Questions about your registration or account? We usually reply within one business day.</span>
      </div>
    </div>

    <div class="vc-messages" #messageList>
      <div *ngIf="loading" class="vc-empty">Loading messages…</div>
      <div *ngIf="!loading && !vendorId" class="vc-empty">
        Please log in to view your messages.
      </div>
      <div *ngIf="!loading && vendorId && messages.length === 0" class="vc-empty">
        No messages yet. Start the conversation below.
      </div>

      <div class="vc-welcome" *ngIf="messages.length > 0">
        You're chatting with our staff — your history stays here if you come back later.
      </div>

      <div
        *ngFor="let message of messages"
        class="vc-row"
        [class.own]="message.senderSide === 'Vendor'"
        [class.has-reactions]="message.vendorReaction || message.staffReaction"
      >
        <div class="vc-bubble" [class.own]="message.senderSide === 'Vendor'">
          <div class="vc-sender" *ngIf="message.senderSide === 'Staff'">
            {{ message.senderDisplayName }}
          </div>
          <div class="vc-text" *ngIf="message.text">{{ message.text }}</div>
          <div class="vc-time">
            {{ message.createdDate + 'Z' | date: 'MMM d, h:mm a' }}
            <span *ngIf="message.senderSide === 'Vendor' && message.isReadByStaff" class="vc-read">✓ Seen</span>
          </div>
          <div class="rx-chips" *ngIf="message.vendorReaction || message.staffReaction">
            <span *ngIf="message.vendorReaction">{{ message.vendorReaction }}</span>
            <span *ngIf="message.staffReaction">{{ message.staffReaction }}</span>
          </div>
        </div>
        <div class="rx-anchor" *ngIf="message.id !== 0">
          <button type="button" class="rx-add" title="React" (click)="toggleReactionPicker(message.id)">🙂</button>
          <div class="rx-picker" *ngIf="reactionPickerFor === message.id">
            <button
              type="button"
              *ngFor="let reaction of reactionOptions"
              [class.active]="message.vendorReaction === reaction"
              (click)="react(message, reaction)"
            >{{ reaction }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="vc-error vc-error-composer" *ngIf="composerError">{{ composerError }}</div>

    <div class="vc-emoji-pop" *ngIf="emojiOpen">
      <button type="button" class="vc-emoji" *ngFor="let emoji of emojis" (click)="addEmoji(emoji)">{{ emoji }}</button>
    </div>

    <div class="vc-composer" *ngIf="vendorId">
      <button type="button" class="vc-tool" (click)="toggleEmoji()" title="Emoji" [class.active]="emojiOpen">😊</button>
      <textarea
        rows="1"
        [(ngModel)]="newMessageText"
        (ngModelChange)="onComposerInput()"
        placeholder="Type your message…"
        (keydown.enter)="$event.preventDefault(); sendMessage()"
        (focus)="emojiOpen = false"
      ></textarea>
      <button type="button" class="vc-send-btn" (click)="sendMessage()" [disabled]="sending || !newMessageText.trim()">
        <svg viewBox="0 0 24 24" fill="none"><path d="M3.4 20.4 20.85 12 3.4 3.6l-.01 6.53L14 12 3.39 13.87l.01 6.53Z" fill="currentColor"/></svg>
      </button>
    </div>
  </div>
</div>
